<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="dedication" role="doc-dedication">
<p class="SP"> </p>
<p class="DED"><span aria-label="7" id="pg_7" role="doc-pagebreak">To the men and women who are helping humankind expand civilization to the stars</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4e1c7dae